import { combineReducers } from 'redux';

import { createCapabilitiesReducer } from 'moet-core';

import { NAME, CAPS } from '../constants';

import addresify from './addresify';
import bpc from './bpc';
import credentials from './credentials';
import data from './data';
import documentUpload from './documentUpload';
import entityTypes from './entityTypes';
import experimentation from './experimentation';
import experiments from './experiments';
import featuresConfig from './featuresConfig';
import freshChat from './freshChat';
import loadingStates from './loadingStates';
import lookupData from './lookupData';
import merchant from './merchant';
import midSelector from './midSelector';
import options from './options';
import partners from './partners';
import organizationEntityTypes from './organizationEntityTypes';
import platforms from './platforms';
import products from './products';
import recaptcha from './recaptcha';
import terms from './terms';

export default () => ({
  [NAME]: combineReducers({
    capabilities: createCapabilitiesReducer(CAPS),
    addresify,
    bpc,
    credentials,
    data,
    documentUpload,
    entityTypes,
    experimentation,
    experiments,
    featuresConfig,
    freshChat,
    loadingStates,
    lookupData,
    merchant,
    midSelector,
    options,
    partners,
    organizationEntityTypes,
    platforms,
    products,
    recaptcha,
    terms,
  }),
});
